import * as Yup from "yup";
export const initialValues = (data) => {
  return {
    ...data,
    ...data?.localized_data,
    image: data?.avatar,
  };
};

export const structure = (supportedLang, t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `image`,
        kind: "upload",
        type: "image",
        label: t("admin_profile.profile_image"),
        placeholder: t("admin_profile.profile_image"),
        text: t("admin_profile.allowed_file_types"),
        width: "47%",
      },
      {
        width: "47%",
      },
    ],
  },
  {
    head: t("admin_profile.personal_details"),
    width: "100%",
    list: [
      {
        name: `name`,
        kind: "input",
        type: "text",
        label: t("admin_profile.name"),
        width: "47%",
        placeholder: t("admin_profile.write_name"),
      },
      {
        name: `phone_number`,
        kind: "input",
        type: "text",
        label: t("admin_profile.phone_number"),
        width: "47%",
        placeholder: t("admin_profile.write_phone_number"),
      },
      {
        name: `email`,
        kind: "input",
        type: "text",
        label: t("admin_profile.email"),
        width: "47%",
        placeholder: t("admin_profile.write_email"),
      },
    ],
  },
];

export const validationSchema = (t) =>
  Yup.object({
    name: Yup.string().required(t("common.required")),
    email: Yup.string().required(t("common.required")),
    phone_number: Yup.string().required(t("common.required")),
  });